const SITE_ANCHOR = 'int-site';
const PRODUCT_LIST_ANCHOR = 'productList';
const LEFT_COLUMN_WIDTH = 768;

const PAGE_TYPES = {
  MODULE: 'module',
  SUBJECT: 'subject',
  HOME_PAGE: 'home_page',
  LANDING_PAGE: 'landing_page',
  CONTACT_US: 'contact_us',
  MODULE_ACCESSIBILITY_STATEMENT: 'module_accessibility',
  QUALIFICATION: 'qualification',
  SUBJECT_LISTING: 'subject_listing_page',
  PRODUCT_LISTING: 'product_listing_page',
  HIGH_LEVEL_CONTENT: 'standard',
  HIGH_lEVEL_CONTENT_CTA: 'careers',
  404: 'n404',
  FORM: 'form',
  POSTGRADUATE_RESEARCH: 'postgraduate_research',
};

const CODE_NAMES = {
  SHORT_COURSE: 'short_course',
};

const ROUTES = {
  SHORT_COURSES: '/courses/short-courses/',
  SUBJECT_ATOZ: '/courses/atoz/',
  MICROCRENTIALS: '/courses/microcredentials/',
  ACCESS_MODULES: '/courses/modules/',
  CREATIVE_ARTS: '/courses/creative-arts/',
  WIDL_FAQS: '/courses/what-is-distance-learning/faqs/',
  POSTGRADUATE_A2Z_SUBJECTS: '/postgraduate/atoz-subjects/',
};

const PRODUCT_TYPES = {
  MODULE_TYPES: {
    UNDERGRADUATE_MODULE: 'Undergraduate Module',
    POSTGRADUATE_MODULE: 'Postgraduate Module',
    ACCESS_MODULE: 'Access Module',
    SHORT_COURSE_FIXED_PRESENTATION: 'Short course - fixed presentation',
    SHORT_COURSE_CONTINUOUS_PRESENTATION: 'Short course - continuous presentation',
    MICROCREDENTIAL: 'Microcredential',
  },
  QUALIFICATION_TYPES: {
    CERTIFICATE_OF_HIGHER_EDUCATION: 'Certificate of Higher Education',
    DIPLOMA_OF_HIGHER_EDUCATION: 'Diploma of Higher Education',
    HONOURS_DEGREE: 'Honours Degree',
    INTEGRATED_MASTER: 'Integrated Master',
    FOUNDATION_DEGREE: 'Foundation Degree',
    OPEN_UNIVERSITY_CERTIFICATE: 'Open University Certificate',
    HIGHER_TECHNICAL_QUALIFICATIONS: 'Higher Technical Qualifications',
    OU_DIPLOMA: 'Open University Diploma',
    MASTERS_DEGREE: 'Masters Degree',
    POSTGRADUATE_DIPLOMA: 'Postgraduate Diploma',
    POSTGRADUATE_CERTIFICATE: 'Postgraduate Certificate',
    TOP_UP_DEGREE: 'Top up Degree',
    GRADUATE_ENTRY_DEGREE: 'Graduate Entry Degree',
    CREATIVE_ARTS_HONOURS_DEGREE: 'Creative Arts Honours Degree',
    CREATIVE_ARTS_CERTIFICATE_OF_HE: 'Creative Arts Certificate of HE',
    OPEN_UNIVERSITY_DIPLOMA: 'Open University Diploma',
  },
};

const PRODUCT_TYPE_CODENAMES = {
  MODULE_TYPES: {
    UNDERGRADUATE_MODULE: 'undergraduate_module',
    POSTGRADUATE_MODULE: 'postgraduate_module',
    ACCESS_MODULE: 'access_module',
    SHORT_COURSE_FIXED_PRESENTATION: 'short_course___fixed_presentation',
    SHORT_COURSE_CONTINUOUS_PRESENTATION: 'short_course',
    MICROCREDENTIAL: 'microcredential',
  },
};

const OPEN_PRODUCTS = {
  OPEN_DEGREES: 'open-degree',
  OPEN_DIPLOMA: 'open-diploma',
  OPEN_CERTIFICATE: 'open-certificate',
};

const FEES_AND_FUNDING_MODEL = {
  DEFAULT: 'default',
  HIGH_LOW_COST_MODEL_1: 'high_low_cost__model_1',
  HIGH_LOW_COST_MODEL_2: 'high_low_cost__model_2',
  HIGH_LOW_COST_MODEL_3: 'high_low_cost__model_3',
  HIGH_LOW_COST_MODEL_4: 'high_low_cost__model_4',
  HIGH_LOW_COST_MODEL_5: 'high_low_cost__model_5',
  OVERRIDE: 'override',
};

const COUNTRIES = {
  ALL_COUNTRIES: 'all',
  UK: 'uk',
  ENGLAND: 'en',
  NORTHERN_IRELAND: 'ni',
  SCOTLAND: 'sc',
  WALES: 'wa',
  CHANNEL_ISLANDS: '_01',
  ISLE_OF_MAN: '_02',
  IRELAND: 'ie',
  APPROVED_STUDY_AREAS: 'eu',
  REST_OF_WORLD: 'oe',
};

const PRODUCT_TYPE_HEADINGS = {
  [PRODUCT_TYPES.MODULE_TYPES.POSTGRADUATE_MODULE]: 'Modules',
  [PRODUCT_TYPES.QUALIFICATION_TYPES.CERTIFICATE_OF_HIGHER_EDUCATION]: 'Certificates of Higher Education',
  [PRODUCT_TYPES.QUALIFICATION_TYPES.DIPLOMA_OF_HIGHER_EDUCATION]: 'Diplomas of Higher Education',
  [PRODUCT_TYPES.QUALIFICATION_TYPES.HONOURS_DEGREE]: 'Honours degrees',
  [PRODUCT_TYPES.QUALIFICATION_TYPES.INTEGRATED_MASTER]: 'Integrated masters degrees',
  [PRODUCT_TYPES.QUALIFICATION_TYPES.FOUNDATION_DEGREE]: 'Foundation degrees',
  [PRODUCT_TYPES.QUALIFICATION_TYPES.OPEN_UNIVERSITY_CERTIFICATE]: 'Open University certificates',
  [PRODUCT_TYPES.QUALIFICATION_TYPES.HIGHER_TECHNICAL_QUALIFICATIONS]: 'Higher Technical Qualifications',
  [PRODUCT_TYPES.QUALIFICATION_TYPES.OU_DIPLOMA]: 'Open University diplomas',
  [PRODUCT_TYPES.QUALIFICATION_TYPES.MASTERS_DEGREE]: 'Masters degrees',
  [PRODUCT_TYPES.QUALIFICATION_TYPES.POSTGRADUATE_DIPLOMA]: 'Postgraduate diplomas',
  [PRODUCT_TYPES.QUALIFICATION_TYPES.POSTGRADUATE_CERTIFICATE]: 'Postgraduate certificates',
  [PRODUCT_TYPES.MODULE_TYPES.ACCESS_MODULE]: 'Access',
};

const POSTGRADUATE_COURSE_TYPES = {
  [PRODUCT_TYPES.QUALIFICATION_TYPES.MASTERS_DEGREE]: 'Masters Degrees',
  [PRODUCT_TYPES.QUALIFICATION_TYPES.POSTGRADUATE_DIPLOMA]: 'Postgraduate Diplomas',
  [PRODUCT_TYPES.QUALIFICATION_TYPES.POSTGRADUATE_CERTIFICATE]: 'Postgraduate Certificates',
};

const RENDER_MODES = {
  STANDARD: 'Standard',
  HEROBANNER: 'Hero',
  NONHERO: 'Non-Hero',
};

const FORM_PAGES = {
  EMAIL_US: {
    FORM_ID: '4',
    DEFAULT_TYPE: 'Enquiry',
    SOQ_QUERY_PARAM: 'soq',
    DEFAULT_SOQ_VALUE: '1',
    DEFAULT_QUEUE_NAME: 'Q-SRS-GENERAL',
    FORM_NAME: '9598',
    SOQ_REGEX: /^\d+$/,
  },
  EMAIL_US_WELSH: {
    FORM_ID: '18',
  },
  REQUEST_PROSPECTUS: {
    FORM_ID: '28',
    DEFAULT_TYPE: 'Enquiry',
    SOQ_QUERY_PARAM: 'soq',
    DEFAULT_SOQ_VALUE: '1',
    DEFAULT_QUEUE_NAME: 'Q-SRS-GENERAL',
    FORM_NAME: '9598',
    SOQ_REGEX: /^\d+$/,
    HEADING: 'Please select up to 3 prospectuses',
    UNDERGRADUATE: 'Undergraduate',
    POSTGRADUATE: 'Postgraduate',
    GENERAL_PROSPECTUS: 'General prospectuses',
    WELSH_PROSPECTUS: 'Welsh prospectuses',
    SUBJECT_AREA_PROSPECTUS: 'Subject area prospectuses',
    WALES_UNDERSCORE_PROSPECTUS: 'welsh_prospectuses',
    CYMRAEG: 'Cymraeg',
    POST: 'Post',
    EMAIL: 'Email',
    PROSPECTUS_MAX_VALIDATION_MESSAGE: 'Prospectuses: should contain no more than 3 choices',
    PROSPECTUS_MIN_VALIDATION_MESSAGE: 'Prospectuses: should contain at least one choice',
    THANK_YOU_PAGE_URL: '/request/prospectus-thank-you',
    PROSPECTUS_TITLE_BY_EMAIL:
      'Your prospectuses have been emailed to you; it’s a small step but it could be the start of something huge',
    PROSPECTUS_TITLE_BY_POST:
      'Your prospectuses have been posted to you; it’s a small step but it could be the start of something huge',
    PROSPECTUS_TITLE_BY_POST_AND_EMAIL_TEXT: 'Your prospectus will be dispatched within 2 working days.',
  },
  REQUEST_PROSPECTUS_WELSH: {
    FORM_ID: '31',
    DEFAULT_TYPE: 'Enquiry',
    SOQ_QUERY_PARAM: 'soq',
    DEFAULT_SOQ_VALUE: '1',
    DEFAULT_QUEUE_NAME: 'Q-Wales-General',
    FORM_NAME: '0068',
    SOQ_REGEX: /^\d+$/,
    HEADING: 'Dewiswch hyd at 3 prosbectws',
    UNDERGRADUATE: 'Israddedig',
    POSTGRADUATE: 'Ôl-raddedig',
    GENERAL_PROSPECTUS: 'General prospectuses',
    WELSH_PROSPECTUS: 'Welsh prospectuses',
    SUBJECT_AREA_PROSPECTUS: 'Subject area prospectuses',
    GENERAL_PROSPECTUS_WELSH_HEADER: 'Prosbectysau cyffredinol',
    SUBJECT_AREA_PROSPECTUS_WELSH_HEADER: 'Prosbectysau meysydd pwnc',
    WALES_UNDERSCORE_PROSPECTUS: 'welsh_prospectuses',
    CYMRAEG: 'Cymraeg',
    POST: 'Post',
    EMAIL: 'Email',
    PROSPECTUS_MAX_VALIDATION_MESSAGE: 'Prosbectysau : ni ddylai gynnwys mwy na 3 dewis',
    PROSPECTUS_MIN_VALIDATION_MESSAGE: 'Prosbectysau : dylid cynnwys o leiaf un dewis',
    THANK_YOU_PAGE_URL: '/request/brosbectws/diolch',
    PROSPECTUS_TITLE_BY_EMAIL:
      'Rydym wedi anfon eich prosbectysau atoch chi; cam bach yw hwn, ond gallai fod yn ddechrau rhywbeth arbennig iawn',
    PROSPECTUS_TITLE_BY_POST:
      'Rydym wedi anfon eich prosbectysau atoch chi; cam bach yw hwn, ond gallai fod yn ddechrau rhywbeth arbennig iawn',
    PROSPECTUS_TITLE_BY_POST_AND_EMAIL_TEXT:
      'Anfonir eich prosbectws o fewn 2 ddiwrnod gwaith.<br />Rydym hefyd wedi eu e-bostio atoch er hwylustod i chi.',
  },
  PARTNERSHIP: {
    FORM_ID: '29',
    DEFAULT_TYPE: 'Enquiry',
    SOQ_QUERY_PARAM: 'soq',
    DEFAULT_SOQ_VALUE: '1',
    DEFAULT_QUEUE_NAME: 'Q-SRS-GO-TO-MARKET',
    PATHWAYS_QUEUE_NAME: 'Q-WALES-LS',
    FORM_NAME: '9598',
    SOQ_REGEX: /^\d+$/,
    HEADING: 'Partnerships Form',
  },
  PARTNERSHIP_WELSH: {
    FORM_ID: '30',
  },
  UG_ASK_A_QUESTION: {
    FORM_ID: '20',
    QUESTION_VALUE: 'my question is not listed',
  },
  CALL_ME_BACK: {
    FORM_ID: '5',
    FORM_QUERY_PARAM: 'formID',
    FORM_NAME: '9670',
    FORM_NAME_REGEX: /^\d{4}/,
    DEFAULT_SOQ_VALUE: '4',
    SOQ_QUERY_PARAM: 'soq',
    SOQ_REGEX: /^\d+$/,
    QUEUE_QUERY_PARAM: 'queue',
    DEFAULT_QUEUE_NAME: 'Q-001',
    DEFAULT_QUEUE_REGEX: /^Q-([1-9][0-9]{2}|[0-9][1-9][0-9]|[0-9]{2}[1-9])$/,
  },
  CREATE_ACCOUNT: {
    FORM_ID: '1',
    FORM_NAME: '9671',
    SAVE_FOR_LATER_FORM_NAME: '9772',
    PROSPECT: 'Prospect',
    INFORMAL_PROSPECT: 'Informal Prospect',
    OPEN_LEARN: 'openlearn',
    OPEN_LEARN_THANK_YOU_URL: '/request/create-account/open-learn-thank-you',
    CREDIT_TRANSFER: '/authentication/login?gig_client_id',
    CREDIT_TRANSFER_THANK_YOU_URL: '/request/create-account/credit-transfer-thank-you',
    MY_ACCOUNT_THANK_YOU_URL: '/request/create-account/thank-you',
    QUERY_STRING_PPT_SAVE_LATER: 'pptsaveforlater=true',
    QUERY_STRING_ADD_TO_SHORTLIST: 'addtoshortlist=true',
    LIST_TYPE_FORMAL: 'formal',
    LIST_TYPE_IN_FORMAL: 'informal',
    DUPLICATE_EMAIL_ERROR_CODE: 'Email address already exist',
    DUPLICATE_EMAIL_ERROR_MESSAGE:
      'The email address you have provided has already been used for an OU account. Please sign in with your existing account details rather than signing up for a new account. If you have forgotten your password you can reset this from our sign in page.',
  },
  FORM_BUILDER: {
    FORM_BUILDER_SUBMISSION_ID: 'form_builder_submission',
    DEFAULT_TYPE: 'Enquiry',
    DEFAULT_SOQ_VALUE: '1',
    DEFAULT_QUEUE_NAME: 'Q-SRS-GENERAL',
    DEFAULT_PROPOSITION_TYPE_SIGNUP: 'BizForm',
    DEFAULT_TYPE_INTERACTION: 'Interaction',
  },
  QUALS_REGISTRATION: {
    FORM_ID: '2',
    FORM_NUMBER: 'QREGUK',
    EMAIL_ID: '0000',
  },
  QUALS_REGISTRATION_ASA: {
    FORM_NUMBER: 'QREGIN',
    EMAIL_ID: 'Email0000ASA',
  },
  QUALS_REGISTRATION_ROW: {
    FORM_NUMBER: '0076',
    EMAIL_ID: 'Email0076',
  },
  QR1_WALES: {
    FORM_ID: '16',
  },
  REGISTER_YOUR_INTEREST: {
    FORM_ID: '101',
  },
  REGISTER_YOUR_ACCOUNT: {
    FORM_ID: '105',
  },
  COMPLAINTS: {
    FORM_ID: '22',
  },
  COMPLAINTS_WELSH: {
    FORM_ID: '24',
  },
  BLENDED_NURSING: {
    FORM_ID: '17',
  },
};

const COUNTRY_CODES = {
  ENGLAND: 'EN|GB',
  NORTHERN_IRELAND: 'NI|GB',
  SCOTLAND: 'SC|GB',
  WALES: 'WA|GB',
};

const COUNTRY_CODE_UK = 'GB';
const COUNTRY_UK = 'United Kingdom';

const MODULE_LISTER_RENDER_MODE = {
  MODULE_STAGE: 'module_stage',
  MODULE_SUMMARY: 'module_summary',
};

const PG_QUAL_MODULE_STATUSES = {
  REGOPEN_AND_PREBOOK: 'regopen-and-prebook',
  PREBOOK_ONLY: 'prebook-only',
  REGOPEN_ONLY: 'regopen-only',
  NO_REGOPEN_OR_PREBOOK: 'no-regopen-or-prebook',
};

const LOCATION = 'location';
const COUNTRY_REGION_OF_RESIDENCY = 'countryDropdown';
const LOCATION_UK = '1';
const LOCATION_ROW = '2';
const CASSIE_RADIO_VALIDATION_MESSAGE = 'Please select a contact preference before submitting the form';
const CASSIE_RADIO_VALIDATION_MESSAGE_WELSH = 'Dewiswch y dull cysylltu a ffafrir gennych cyn cyflwyno eich ffurflen';

const THANK_YOU_PATHS = {
  [FORM_PAGES.QUALS_REGISTRATION.FORM_ID]: '/request/thank-you/ug-qual-reg-thank-you',
  [FORM_PAGES.EMAIL_US.FORM_ID]: '/contact/new/thank-you',
  [FORM_PAGES.CALL_ME_BACK.FORM_ID]: `/request/call-me-back/thank-you`,
  [FORM_PAGES.COMPLAINTS.FORM_ID]: `/request/complaints/thank-you`,
  [FORM_PAGES.COMPLAINTS_WELSH.FORM_ID]: `/request/thank-you-pages/0103-welsh-complaints-thank-you`,
  [FORM_PAGES.QR1_WALES.FORM_ID]: '/request/thank-you-pages/0053-wales-registration-form-thank-you',
  [FORM_PAGES.PARTNERSHIP.FORM_ID]: '/request/wales-partnerships-thank-you',
  [FORM_PAGES.PARTNERSHIP_WELSH.FORM_ID]: '/request/cymraeg/diolch/0097-wales-partnerships',
  [FORM_PAGES.BLENDED_NURSING.FORM_ID]: '/request/thank-you-pages/0096-blended-nursing-application-form-request',
  [FORM_PAGES.EMAIL_US_WELSH.FORM_ID]: '/request/e-bostiwch-ni/diolch',
  [FORM_PAGES.REQUEST_PROSPECTUS_WELSH.FORM_ID]: '/request/brosbectws/diolch',
  [FORM_PAGES.REQUEST_PROSPECTUS.FORM_ID]: '/request/prospectus-thank-you',
  [FORM_PAGES.REGISTER_YOUR_INTEREST.FORM_ID]: '/courses/register-your-interest/thank-you',
  [FORM_PAGES.CREATE_ACCOUNT.FORM_ID]: [
    FORM_PAGES.CREATE_ACCOUNT.OPEN_LEARN_THANK_YOU_URL,
    FORM_PAGES.CREATE_ACCOUNT.CREDIT_TRANSFER_THANK_YOU_URL,
    FORM_PAGES.CREATE_ACCOUNT.MY_ACCOUNT_THANK_YOU_URL,
  ],
};

const SEARCH_BAR_BANNER_LAYOUTS = {
  FULL_WIDTH: 'fullWidth',
  SEARCH_BAR_WITH_BANNER: 'searchBarWithBanner',
};

export {
  SITE_ANCHOR,
  PRODUCT_LIST_ANCHOR,
  LEFT_COLUMN_WIDTH,
  CASSIE_RADIO_VALIDATION_MESSAGE,
  CASSIE_RADIO_VALIDATION_MESSAGE_WELSH,
  CODE_NAMES,
  ROUTES,
  PAGE_TYPES,
  PRODUCT_TYPES,
  PRODUCT_TYPE_CODENAMES,
  PRODUCT_TYPE_HEADINGS,
  POSTGRADUATE_COURSE_TYPES,
  OPEN_PRODUCTS,
  FEES_AND_FUNDING_MODEL,
  COUNTRIES,
  RENDER_MODES,
  FORM_PAGES,
  COUNTRY_CODES,
  LOCATION,
  COUNTRY_REGION_OF_RESIDENCY,
  LOCATION_UK,
  LOCATION_ROW,
  MODULE_LISTER_RENDER_MODE,
  PG_QUAL_MODULE_STATUSES,
  COUNTRY_CODE_UK,
  COUNTRY_UK,
  THANK_YOU_PATHS,
  SEARCH_BAR_BANNER_LAYOUTS,
};
